import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCustomers, Customer } from "@/contexts/CustomerContext";
import { useAuth } from "@/contexts/AuthContext";
import { ArrowLeft, Save } from "lucide-react";

const STATUS_OPTIONS: Customer["status"][] = ["new", "active", "hot_lead", "stalled", "closed"];

export default function NewCustomer() {
  const navigate = useNavigate();
  const { addCustomer } = useCustomers();
  const { user } = useAuth();
  const [form, setForm] = useState({
    name: "", phone: "", email: "", status: "new" as Customer["status"],
    budget: "", needs: "", notes: "", assignedTo: user?.name || "",
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.name || !form.phone) return;
    const c = await addCustomer(form);
    navigate(`/customers/${c.id}`);
  };

  const update = (field: string, value: string) => setForm({ ...form, [field]: value });

  return (
    <div className="page" style={{ maxWidth: 700 }}>
      <div className="detail-header">
        <button className="btn btn-secondary" onClick={() => navigate("/customers")}>
          <ArrowLeft size={16} /> Back
        </button>
      </div>
      <div className="card">
        <h2 style={{ marginBottom: 20 }}>New Customer</h2>
        <form onSubmit={handleSubmit}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
            <div className="form-group"><label>Name *</label><input value={form.name} onChange={(e) => update("name", e.target.value)} required /></div>
            <div className="form-group"><label>Phone *</label><input value={form.phone} onChange={(e) => update("phone", e.target.value)} required /></div>
            <div className="form-group"><label>Email</label><input type="email" value={form.email} onChange={(e) => update("email", e.target.value)} /></div>
            <div className="form-group"><label>Budget</label><input value={form.budget} onChange={(e) => update("budget", e.target.value)} placeholder="e.g. $3,000 - $5,000" /></div>
          </div>
          <div className="form-group">
            <label>Status</label>
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
              {STATUS_OPTIONS.map((s) => (
                <button type="button" key={s} className={`filter-chip ${form.status === s ? "active" : ""}`}
                  onClick={() => update("status", s)}>{s.replace("_", " ")}</button>
              ))}
            </div>
          </div>
          <div className="form-group"><label>Needs</label><input value={form.needs} onChange={(e) => update("needs", e.target.value)} placeholder="e.g. Living room set, Dining table" /></div>
          <div className="form-group"><label>Notes</label><textarea value={form.notes} onChange={(e) => update("notes", e.target.value)} rows={3} /></div>
          <button type="submit" className="btn btn-primary" style={{ marginTop: 8 }}><Save size={16} /> Save Customer</button>
        </form>
      </div>
    </div>
  );
}
